import styled, { css } from 'styled-components';

import {
    Image,
    mediaMixin,
    Card,
    IconChevronRightCircle,
    token,
} from '@zillow/constellation';

export const StyledCard = styled(Card)`
    height: 150px;
    cursor: pointer;
`;

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
    color: ${token('colors.brand')};
    flex-grow: 1;
    position: relative;
    bottom: -2px;
    left: 8px;

    ${mediaMixin('lg', css`
        left: 0px;
    `)}
`;

export const StyledImageForSvg = styled(Image)`
    position: relative;
    bottom: 10px;
    height: 35px;
`;
